import styled from 'styled-components';
import { MdChevronRight } from 'react-icons/md';

const Wrapper = styled.div`
  font-size: ${({ theme }) => theme.size(2)};
  color: ${({ theme }) => theme.textLighter};
  padding-left: ${({ theme }) => theme.spacing(0.5)};
  display: flex;
`;

const CardLinkArrow = () => (
  <Wrapper>
    <MdChevronRight />
  </Wrapper>
);

export default CardLinkArrow;
